import { useContext } from 'react';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { Paper, Grid } from '@mui/material';
import CheckBoxInput from '../../../../Components/CheckBoxInput';
import useCommonStyles from '../../../../commonStyles';
import PageHeading from '../../../../Components/PageHeading';

/**
 * @name UnmuteAfterInteractionOptimizationConfig
 * @description This component is an editor for `unmuteAfterInteractionOptimization` configuration.
 * ```
 * unmuteAfterInteractionOptimization: {
 *   "enabled": true,
 *   "enableOnIos": true
 * }
 * ```
 * @param {{keyData: 'experimentalFeaturesData.unmuteAfterInteractionOptimization'}} keyData - A key used to identify the configuration in the `rawConfig` object.
 */
const UnmuteAfterInteractionOptimizationConfig = ({ keyData, featureDescription }) => {
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);
	const commonStyleClasses = useCommonStyles();
	return (
		<Paper className={commonStyleClasses.mainPagePaperMarginStyle}>
			<PageHeading
				headingName="Advanced Optimization"
				headingPath={['Dashboard', 'Framerate', 'Experiments', 'Advanced Optimization']}
				description="Manage Unmute After Interaction Optimization Configuration"
				showInfoButton={true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={0} style={{ marginTop: '1rem', width: '94%', marginLeft: '5rem' }}>
				<Grid item xs={3}>
					<CheckBoxInput
						keyData={keyData + '.enableOnIos'}
						label="Ios Enabled"
						disabled={false}
						defaultChecked={false}
						style={{ marginTop: '4rem' }}
						object={rawConfig}
						updateObject={updateRawConfig}
					/>
				</Grid>
			</Grid>
		</Paper>
	);
};

export default UnmuteAfterInteractionOptimizationConfig;
